// extracted by mini-css-extract-plugin
export default {"wrapper":"example_wrapper__6jbK1","primary":"example_primary__uIi7Y","secondary":"example_secondary__95FOd","integration":"example_integration__wlx5s"};